import React, { ReactNode } from 'react';
import { Box, SwipeableDrawer as MuiSwipeableDrawer } from '@mui/material';
import { borderRadius, customSizes, palette, spaces } from '../../assets/styles/themes/tokens';

interface SwipeableDrawerProps {
  open: boolean;
  children: ReactNode | ReactNode[];
  onClose: () => void;
}

const drawerStyles = {
  '& .MuiDrawer-paper': {
    borderTopLeftRadius: borderRadius.md,
    borderTopRightRadius: borderRadius.md,
    height: customSizes.swipeableDrawer.height,
    paddingX: spaces.md,
    paddingBottom: spaces.xl,
  }
};

const dragIndicatorStyles = {
  width: customSizes.swipeableDrawer.dragIndicatorWidth,
  height: customSizes.swipeableDrawer.dragIndicatorHeight,
  backgroundColor: palette.elevation.outlined,
  borderRadius: borderRadius.xs,
  margin: `${spaces.xs} auto ${spaces.xxs}`,
};

const SwipeableDrawer = ({ open, onClose, children }: SwipeableDrawerProps) => {
  return (
    <MuiSwipeableDrawer
      anchor='bottom'
      open={open}
      onClose={onClose}
      onOpen={() => {}} // INFO: this is a placeholder for the required onOpen prop 
      disableSwipeToOpen
      ModalProps={{
        keepMounted: true,
      }}
      sx={drawerStyles}
    >
      <Box sx={dragIndicatorStyles} />
      {children}
    </MuiSwipeableDrawer>
  );
};

export default SwipeableDrawer;
